<template>
<div class="swaychat-modal-content swaychat-rate-success swaychat-fadeInUp">
  <button class="swaychat-modal-close swaychat-button-close" @click="cancel">×</button>
  <div class="swaychat-rate-wrapper">
    <div class="swaychat-rate">
      <h5>{{ getLang.send_chat_transcript_to }}</h5>
    </div>
  </div>
  <div class="swaychat-form">
    <form novalidate @submit.prevent="send" v-if="!loading && !success && !error" class="swaychat-fadeInUp">

      <input-form-component ref="input" type="email" name="email" :error="emailError" :label="getLang.enter_email_address" v-model="email"></input-form-component>
      <button-form-component type="submit" expand="true" primary="true" :label="getLang.send"></button-form-component>
      <button-form-component @click="cancel" type="button" expand="true" outline="true" :label="getLang.cancel"></button-form-component>

    </form>

    <div id="swaychat-form-transcript-success" class="swaychat-row swaychat-modal-success swaychat-bounceIn" v-if="loading" >
      <h5>{{ getLang.loading }} <span>{{ getLang.please_wait }}</span></h5>
    </div>

    <div id="swaychat-form-transcript-success" class="swaychat-row swaychat-modal-success swaychat-bounceIn" v-if="success" >
      <h5>{{ getLang.transcript_sent_to }} <span>{{ email }}</span></h5>
    </div>

    <div id="swaychat-form-transcript-error" class="swaychat-row swaychat-modal-success swaychat-bounceIn" v-if="error">
      <h5>{{ getLang.error_sending_to }} <span>{{ email }}</span></h5>
    </div>

    <button-form-component v-if="success || error" type="button" @click="reset" expand="true" primary="true" :label="getLang.sendAnother"></button-form-component>

  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import ButtonFormComponent from './input/ButtonFormComponent.vue'
import InputFormComponent from './input/InputFormComponent.vue'


export default {
  components: {
    InputFormComponent,
    ButtonFormComponent
  },
  computed: {
    ...mapGetters([
      'getLang',
      'getSession',
      'getMeta'
    ])
  },
  mounted() {

    if (this.getMeta.email)
    this.email = this.getMeta.email

  },
  data() {
    return {
      email: '',
      emailError: false,
      error: false,
      success: false,
      loading: false
    }
  },
  methods: {
    send() {

      const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let email = this.email.trim()

      if (!emailRE.test(email)) {
        this.emailError = true
        this.$refs.input.$refs.input.focus()
        return
      }

      this.emailError = false
      this.loading = true

      this.$store.dispatch('requestTranscript', email).then(()=>{
        this.success = true
      })
      .catch(()=>{
        this.error = true
      })
      .then(()=>{
        this.loading = false
      })

    },
    reset() {
      this.success = false
      this.error = false
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>
